const chirhosApi = require('@chirhos/chirhos-api')

export default class ChiRhosClient {
  constructor(options = {}) {
    this.basePath = options.basePath
  }
  api() {
    var basePath = this.basePath
    var _apiBasePath = process.env.VUE_APP_CHIRHOS_DOMAIN

    var _identity = getSavedState('auth.identity')
      ? getSavedState('auth.identity')
      : {}

    var _chirhosConfig = getSavedState('chirhos.config')
      ? getSavedState('chirhos.config')
      : {}

    var _accessToken = _identity ? _identity.accessToken || '' : ''

    if (!_accessToken) {
      throw new Error('Please provide an access token.')
    }

    if (basePath) _apiBasePath = basePath.replace(/\/+$/, '')

    if (_chirhosConfig && _chirhosConfig.apiUrl) {
      _apiBasePath = _chirhosConfig.apiUrl
    }

    var _chirhosApiClient = new chirhosApi.ApiClient({
      basePath: _apiBasePath,
      accessToken: _accessToken,
    })

    return _chirhosApiClient
  }
}

// retrieve content from local storage for a given key
function getSavedState(key) {
  return JSON.parse(window.localStorage.getItem(key))
}

ChiRhosClient.instance = new ChiRhosClient()
// ChiRhosClient.next = new ChiRhosClientV2()
